import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import EinsteinLogo from '../../static/img/einstein-icon-36x36.svg';
import { Icon, PageHeader } from '@salesforce/design-system-react';

import './Header.scss';

class Header extends Component {
  blockLinkNavigation(e, criteria) {
    if (this.props.modalData) {
      const { name, unsavedChangesMessage } = this.props.modalData;
      if (!!criteria) {
        this.props.actions.openModal(name, unsavedChangesMessage);
        e.preventDefault();
      }
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { route } = this.props;

    const trailItems = [];
    let current = 'components.ecs.nav.ecs';

    const einsteinLogo = (
      <img
        className="einstein-logo"
        src={EinsteinLogo}
        alt="Einstein Logo"
        height="36px"
        width="36px"
      />
    );

    const setupLogo = (
      <Icon
        category="utility"
        name="setup"
        size="medium"
        className="slds-icon-utility-setup"
        inverse
      />
    );

    let icon = einsteinLogo;
    let classname = 'einstein-page-header';

    const ECS = (
      <span className="static-breadcrumb">
        <FormattedMessage id="components.ecs.nav.ecs" />
      </span>
    );
    const SETTINGS = (
      <Link
        to={{ pathname: '/root/settings' }}
        onClick={e => this.blockLinkNavigation(e, this.props.blockNavCriteria)}
      >
        <FormattedMessage id="components.ecs.nav.settings" />
      </Link>
    );
    const DISTRIBUTION = (
      <Link to={{ pathname: '/root/distribution' }}>
        <FormattedMessage id="components.ecs.nav.distribution" />
      </Link>
    );

    const ASSETS_VIA_DISTRIBUTION = (
      <Link to={{ pathname: '/assets/distribution' }}>
        <FormattedMessage id="components.ecs.nav.assets" />
      </Link>
    );
    const SETUP = (
      <span className="static-breadcrumb">
        <FormattedMessage id="components.ecs.nav.setup" />
      </span>
    );
    const ANALYTICS = (
      <Link to={{ pathname: '/analytics' }}>
        <FormattedMessage id="components.ecs.nav.analytics" />
      </Link>
    );

    const SELECTIONS = (
      <Link to={{ pathname: '/selections' }}>
        <FormattedMessage id="components.ecs.nav.selections" />
      </Link>
    );

    switch (route.url) {
      case '/settings':
        trailItems.push(ECS);
        current = 'components.ecs.nav.settingsHome';
        break;
      case '/assets':
      case '/assets/distribution':
        trailItems.push(ECS);
        trailItems.push(DISTRIBUTION);
        current = 'components.ecs.nav.assets';
        break;
      case '/assets/settings':
        trailItems.push(ECS);
        trailItems.push(DISTRIBUTION);
        current = 'components.ecs.nav.assets';
        break;
      case '/attributes':
      case '/attributes/asset':
        trailItems.push(ECS);
        trailItems.push(SETTINGS);
        current = 'components.ecs.nav.attributes';
        break;
      case '/attributes/profile':
        trailItems.push(ECS);
        trailItems.push(SETTINGS);
        current = 'components.ecs.nav.profileAttributes';
        break;
      case '/classes':
        trailItems.push(ECS);
        trailItems.push(SETTINGS);
        current = 'components.ecs.nav.classes';
        break;
      case '/profile':
        trailItems.push(ECS);
        current = 'components.ecs.nav.profile';
        break;
      case '/profiles':
        trailItems.push(ECS);
        trailItems.push(SETTINGS);
        current = 'components.ecs.nav.profiles';
        break;
      case '/rules':
        trailItems.push(ECS);
        trailItems.push(SETTINGS);
        current = 'components.ecs.nav.rules';
        break;
      case '/catalogs/distribution':
      case '/catalogs':
        trailItems.push(ECS);
        trailItems.push(DISTRIBUTION);
        trailItems.push(ASSETS_VIA_DISTRIBUTION);
        current = 'components.ecs.nav.catalogs';
        break;
      case '/catalogs/settings':
        trailItems.push(ECS);
        trailItems.push(SETTINGS);
        trailItems.push(ASSETS_VIA_DISTRIBUTION);
        current = 'components.ecs.nav.catalogs';
        break;
      case '/setup':
        trailItems.push(SETUP);
        current = 'components.ecs.nav.ecs';
        icon = setupLogo;
        classname = 'setup-page-header';
        break;
      case '/fallback':
        trailItems.push(ECS);
        trailItems.push(SETTINGS);
        current = 'components.ecs.nav.fallback';
        break;
      case '/analytics':
        trailItems.push(ECS);
        current = 'components.ecs.nav.analytics';
        break;
      case '/analytics/reports':
        trailItems.push(ECS);
        trailItems.push(ANALYTICS);
        current = 'components.ecs.nav.analytics';
        break;
      case '/selections':
        trailItems.push(ECS);
        trailItems.push(ANALYTICS);
        current = 'components.ecs.nav.selections';
        break;
      case '/distribution':
        trailItems.push(ECS);
        current = 'components.ecs.nav.distribution';
        break;
      case '/root':
      case '/root/analytics':
      case '/root/distribution':
      case '/root/settings':
        trailItems.push(ECS);
        let baseRoute = route.url.replace('/root/', '');
        if (!baseRoute.length) {
          baseRoute = 'distribution';
        }
        current = `components.ecs.nav.${baseRoute}`;
        break;
      default:
        break;
    }
    if (route.path === '/selections/:subscriber/:jobId/:blockId') {
      trailItems.push(ECS);
      trailItems.push(ANALYTICS);
      trailItems.push(SELECTIONS);
      current = 'components.ecs.nav.selectionDetails';
    }

    return (
      <PageHeader
        title={
          this.props.title ||
          formatMessage({
            id: current || 'components.ecs.header.title'
          })
        }
        label={formatMessage({ id: 'components.ecs.header.title' })}
        icon={icon}
        variant="object-home"
        trail={trailItems}
        className={classname}
        onRenderActions={this.props.onRenderActions}
      />
    );
  }
}

Header.propTypes = {
  route: PropTypes.object,
  onRenderActions: PropTypes.func,
  title: PropTypes.string,
  intl: intlShape.isRequired
};

export default injectIntl(Header);
